export default function (state, {name, field, value}) {
    let col = state.columns.filter(i => {
        return i.name === name;
    })[0];
    if (!col) return;
    col[field] = value;
}